// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/css/" + chunkId + "." + {"16":"a1fc6ecb","189":"8e9681a5","222":"8d3b25c1","319":"d0fccdbb","327":"c424db87","336":"ae081546","464":"79d49edb","506":"1a9731a0","606":"e1ef2930"}[chunkId] + ".css";
};